module.exports = __webpack_public_path__ + "img/tcc.3ef9cff0.jpeg";